import type React from 'react';
import { cn } from '../../../utils/utils';

interface BadgeProps {
    variant?: 'default' | 'success' | 'warning' | 'danger' | 'primary';
    children: React.ReactNode;
    className?: string;
}

export function BadgeCustom({ variant = 'default', children, className, ...props }: BadgeProps) {
    const variantClasses = {
        default: 'bg-gray-qm-50 text-gray-qm-800',
        success: 'bg-success-200 text-success-50',
        warning: 'bg-warning-200 text-warning-50',
        danger: 'bg-error-200 text-error-50',
        primary: 'bg-primary text-white',
    };

    return (
        <span
            className={cn(
                'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap',
                variantClasses[variant],
                className,
            )}
            {...props}
        >
            {children}
        </span>
    );
}

export default BadgeCustom;
